export enum TabsVariant {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
